/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SpecialPaymentAmountType = 'FIXED' | 'PERCENT' | 'TAX_RETURN';

export const SpecialPaymentAmountType = {
    FIXED: 'FIXED' as SpecialPaymentAmountType,
    PERCENT: 'PERCENT' as SpecialPaymentAmountType,
    TAX_RETURN: 'TAX_RETURN' as SpecialPaymentAmountType
};

